/**
 * 객체에서 undefined 또는 null 값을 가진 key를 제거하는 함수
 * @param obj 정리할 대상 객체
 * @returns undefined나 null 값이 제거된 객체
 */
export default function removeNullUndefined<T extends Record<string, any>>(obj: T): any {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => !isInvalidValue(value)));
}

function isInvalidValue(value: any): boolean {
  // false는 유효한 값으로 처리
  if (value === false) return false;
  const invalidValues = [
    undefined,
    null,
    '',
    'all',
    -1,
    Array.isArray(value) && value.length === 0,
  ];
  return invalidValues.includes(value);
}
